/**
 * HOOK: usePricingItems
 * CRUD sur la grille tarifaire (table pricing_items, 00153).
 * Volume minuscule (quelques items par édition) : on charge tout et la page
 * filtre par produit côté client. Écritures gatées superadmin par RLS.
 */

import { useCRUD } from './useCRUD';
import type { CreatePricingItemDto, PricingItem, UpdatePricingItemDto } from '../types/pricingItem';

export function usePricingItems() {
  const crud = useCRUD<PricingItem, CreatePricingItemDto, UpdatePricingItemDto>('pricing_items', {
    select: '*',
    orderBy: { column: 'sort_order', ascending: true },
  });

  return {
    pricingItems: crud.data,
    loading: crud.loading,
    error: crud.error,
    refresh: crud.refresh,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
  };
}
